import { SynchronizedTime } from '@exodus/basic-utils';
import createIconsStorageModule from '@exodus/storage-icons-browser';
import Emitter from '@exodus/wild-emitter';
import { assetPlugins, combinedAssetsList } from '@passkeys/assets';

import fetch from './fetch.js';
import getBuildMetadata from './get-build-metadata.js';
import createStorage from './storage.js';
import createLogger from '../../utils/logger.js';

const adapters = {
  createLogger,
  legacyPrivToPub: {},
  storage: createStorage(),
  unsafeStorage: createStorage(),
  seedStorage: createStorage(),
  migrateableStorage: createStorage(),
  fetch,
  freeze: Object.freeze,
  assetPlugins,
  combinedAssetsList,
  customTokensStorage: createStorage().namespace('customTokens'),
  iconsStorage: createIconsStorageModule({ storage: createStorage() }),
  getBuildMetadata,
  synchronizedTime: SynchronizedTime,
  port: new Emitter(),
};

export type Adapters = typeof adapters;

export default adapters;
